import { useEffect } from 'react';
import { TERMINAL_THEMES } from '../utils/terminalThemes';

// Default theme ID
const DEFAULT_THEME_ID = 'easy-invoice-theme';

function applyThemeToDOM(theme) {
  const root = document.documentElement;
  const c = theme.colors;

  root.style.setProperty('--color-background', c.background);
  root.style.setProperty('--color-surface', c.surface);
  root.style.setProperty('--color-surface-hover', c.surfaceHover);
  root.style.setProperty('--color-surface-elevated', c.surfaceElevated);
  root.style.setProperty('--color-text', c.text);
  root.style.setProperty('--color-text-secondary', c.textSecondary);
  root.style.setProperty('--color-text-muted', c.textMuted);
  root.style.setProperty('--color-text-on-primary', c.textOnPrimary || '#ffffff');
  root.style.setProperty('--color-primary', c.primary);
  root.style.setProperty('--color-primary-hover', c.primaryHover);
  root.style.setProperty('--color-primary-light', c.primaryLight);
  root.style.setProperty('--color-primary-subtle', c.primarySubtle || c.surfaceElevated);
  root.style.setProperty('--color-secondary', c.secondary);
  root.style.setProperty('--color-secondary-hover', c.secondaryHover);
  root.style.setProperty('--color-accent', c.accent);
  root.style.setProperty('--color-accent-hover', c.accentHover);
  root.style.setProperty('--color-success', c.success);
  root.style.setProperty('--color-border', c.border);
  root.style.setProperty('--color-border-subtle', c.borderSubtle);
  root.style.setProperty('--shadow-color', c.shadow);

  // Shadows derived from shadow color
  root.style.setProperty('--shadow-small', `0 1px 3px ${c.shadow}`);
  root.style.setProperty('--shadow-medium', `0 4px 6px ${c.shadow}`);
  root.style.setProperty('--shadow-large', `0 10px 20px ${c.shadow}`);
  root.style.setProperty('--shadow-subtle', `0 2px 4px ${c.shadow}`);

  // Palette swatches for preview
  if (theme.palette) {
    theme.palette.forEach((color, i) => {
      root.style.setProperty(`--theme-color-${i + 1}`, color);
    });
  }
}

export function getThemeById(id) {
  return TERMINAL_THEMES.find(t => t.id === id);
}

export function getDefaultTheme() {
  return getThemeById(DEFAULT_THEME_ID) || TERMINAL_THEMES[0];
}

export function loadAndApplyTheme() {
  const savedId = localStorage.getItem('colorTheme') || DEFAULT_THEME_ID;
  const theme = getThemeById(savedId) || getDefaultTheme();
  applyThemeToDOM(theme);
  return theme;
}

export function setTheme(themeId) {
  const theme = getThemeById(themeId);
  if (!theme) return;
  localStorage.setItem('colorTheme', themeId);
  // Remove legacy darkMode key — isDark is part of the theme now
  localStorage.removeItem('darkMode');
  applyThemeToDOM(theme);
}

function ThemeInitializer() {
  useEffect(() => {
    loadAndApplyTheme();
  }, []);

  return null;
}

export default ThemeInitializer;
